import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Divider, Spin, Switch, Tabs } from "antd";
import { getroutinglevelsCountry, getTimeZones } from "../../API/api";
import MultiSelectCM from "../MultiSelectCm/MultiSelectCm";
import { filterVisibleTopics } from "../../utils";
import { filtercmDomains } from "../../utils";
import { DaysArr, hoursArr } from "../../Constants";
import { toast } from "react-toastify";
const submitRatingSuccessToast = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
export default function EditRoleExpert({ data, onChangeFunc, roleId }) {
  if (data.blackoutPeriod === undefined) {
    data.blackoutPeriod = {};
    data.blackoutPeriod.id = null;
    data.blackoutPeriod.workTimings = {};
  }
  if (data.attributes[roleId].routingLevels === undefined) {
    data.attributes[roleId].routingLevels = {};
  }
  const userState = useSelector((state) => state.user);
  const [visibleTopics, setVisibleTopics] = useState(
    filterVisibleTopics(userState.expertTopics),
  );
  const [selecetedDays, setSelectedDays] = useState([]);
  const [fromHours, setFromHours] = useState([]);
  const [toHours, setToHours] = useState([]);
  const [AllHours, setAllHours] = useState(hoursArr);
  const onChangeDays = (val) => {
    setSelectedDays(val);
  };
  const onChangeTo = (val) => {
    setToHours(val);
  };
  const onChangeFrom = (val) => {
    setFromHours(val);
    setToHours([]);
    let toHourdata = hoursArr.filter((obj) => {
      if (parseInt(val.value) < parseInt(obj.value)) {
        return obj;
      }
    });
    setAllHours(toHourdata);
  };
  const [state, setState] = useState({
    region:
      data.attributes[roleId].routingLevels.atr2 === undefined
        ? []
        : {
            name: data.attributes[roleId].routingLevels.atr2,
            value: data.attributes[roleId].routingLevels.atr2,
            label: data.attributes[roleId].routingLevels.atr2,
          },
    currentCountry:
      data.attributes[roleId].routingLevels.atr1 === undefined
        ? []
        : {
            name: data.attributes[roleId].routingLevels.atr1,
            value: data.attributes[roleId].routingLevels.atr1,
            label: data.attributes[roleId].routingLevels.atr1,
          },
    countryList: [],
    timeZone:
      data.blackoutPeriod.blackoutTimezone === undefined
        ? []
        : {
            name: data.blackoutPeriod.blackoutTimezone,
            value: data.blackoutPeriod.blackoutTimezone,
            label: data.blackoutPeriod.blackoutTimezone,
          },
    domains:
      data.attributes[roleId].domains === undefined
        ? []
        : filtercmDomains(data.attributes[roleId].domains, visibleTopics),
    global:
      data.attributes[roleId].routingLevels.global === undefined
        ? false
        : data.attributes[roleId].routingLevels.global,
    si: data.seekerIdentity === undefined ? false : data.seekerIdentity,
    reroute:
      data.attributes[roleId].reroute === undefined
        ? false
        : data.attributes[roleId].reroute,
    ces:
      data.expertScoreAllowed === undefined ? false : data.expertScoreAllowed,
    iq:
      data.attributes[roleId].routingLevels.routeQuestion === undefined
        ? false
        : data.attributes[roleId].routingLevels.routeQuestion,
    zoneList: [],
    selectedWorkingHours:
      data.blackoutPeriod.workTimings === undefined
        ? []
        : Object.entries(data.blackoutPeriod.workTimings),
  });
  const cmState = useSelector((state) => state.cmRoot);
  useEffect(() => {
    if (
      data.attributes[roleId].routingLevels.atr2 !== undefined &&
      state.countryList.length === 0
    ) {
      getroutinglevelsCountry(data.attributes[roleId].routingLevels.atr2).then(
        (res) => {
          if (res === undefined) return;
          // setState({ ...state, countryList: res });
          getTimeZones().then((res2) => {
            if (res2 === undefined) return;
            setState({ ...state, zoneList: res2, countryList: res });
          });
        },
      );
    } else {
      getTimeZones().then((res) => {
        if (res === undefined) return;
        setState({ ...state, zoneList: res });
      });
    }
  }, []);

  const optionsWithSelectAllDomains = [
    { label: "Select All", value: "__all__" },
    ...visibleTopics,
  ];

  const onChangeDomains = (value = []) => {
    const isSelectAll = value.some((item) => item.value === "__all__");

    const selectedDomains = isSelectAll ? visibleTopics : value;

    let origData = { ...data };

    setState({
      ...state,
      domains: selectedDomains,
    });

    origData.attributes[roleId].domains = selectedDomains.map((dm) => dm.value);
  };
  const onChangeTimezone = (value) => {
    setState({ ...state, timeZone: value });
    if (data.blackoutPeriod === undefined) {
      data.blackoutPeriod = {};
      data.blackoutPeriod.id = null;
    }
    // data.blackoutPeriod.id=value.value;
    data.blackoutPeriod.blackoutTimezone = value.label;
    data.blackoutPeriod.blackoutEnabled = true;
  };
  const onChangeRegion = (value) => {
    // console.log('hello');
    let origData = { ...data };
    if (state.region.value === value.value) {
      setState({ ...state, region: [], currentCountry: [], countryList: [] });
      delete origData.attributes[roleId].routingLevels.atr2;
      delete origData.attributes[roleId].routingLevels.atr1;
    } else {
      getroutinglevelsCountry(value.value).then((res) => {
        if (res === undefined) return;
        setState({
          ...state,
          region: value,
          currentCountry: [],
          countryList: res,
        });
        origData.attributes[roleId].routingLevels.atr2 = value.value;
        delete origData.attributes[roleId].routingLevels.atr1;
      });
    }
  };

  const onChangeCountry = (value) => {
    let origData = { ...data };
    if (state.currentCountry.value === value.value) {
      setState({ ...state, currentCountry: [] });
      delete origData.attributes[roleId].routingLevels.atr1;
    } else {
      setState({ ...state, currentCountry: value });
      origData.attributes[roleId].routingLevels.atr1 = value.value;
    }
  };
  const onChangeSwitches = (key, val) => {
    let origData = { ...data };
    if (key === "si") {
      setState({ ...state, si: val });
      data.seekerIdentity = val;
    }
    if (key === "g") {
      setState({ ...state, global: val });
      data.attributes[roleId].routingLevels.global = val;
    }
    if (key === "rr") {
      setState({ ...state, reroute: val });
      data.attributes[roleId].reroute = val;
    }
    if (key === "ces") {
      setState({ ...state, ces: val });
      data.expertScoreAllowed = val;
    }
    if (key === "iq") {
      setState({ ...state, iq: val });
      data.attributes[roleId].routingLevels.routeQuestion = val;
    }
  };
  const workingHors = () => {
    if (selecetedDays.length === 0) {
      toast.error(
        submitRatingSuccessToast("Select days to add working hours."),
        {
          position: toast.POSITION.TOP_RIGHT,
        },
      );
      return;
    }
    if (Array.isArray(fromHours) || Array.isArray(toHours)) {
      toast.error(
        submitRatingSuccessToast("Select hours to add working hours."),
        {
          position: toast.POSITION.TOP_RIGHT,
        },
      );
      return;
    }
    selecetedDays.filter((obj) => {
      data.blackoutPeriod.workTimings[obj.value] =
        `${fromHours.value}-${toHours.value}`;
    });
    setState({
      ...state,
      selectedWorkingHours: Object.entries(data.blackoutPeriod.workTimings),
    });
    setToHours([]);
    setFromHours([]);
    setSelectedDays([]);
  };
  const onDeleteWorkHour = (day) => {
    // console.log(data.blackoutPeriod.workTimings[day]);
    delete data.blackoutPeriod.workTimings[day];
    // console.log(data, Object.entries(data.blackoutPeriod.workTimings));
    setState({
      ...state,
      selectedWorkingHours: Object.entries(data.blackoutPeriod.workTimings),
    });
  };
  return (
    <div>
      <div className="mt-2">
        <span style={{ fontSize: "16px" }}>
          Set Expert Location and working hours&nbsp;
        </span>
      </div>
      <div className="mt-3" style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>Region&nbsp;</div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              value={state.region}
              options={cmState.regionData}
              isMulti={false}
              onChangeFunc={onChangeRegion}
              isClearable={true}
            />
          </div>
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>Country&nbsp;</div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              onChangeFunc={onChangeCountry}
              value={state.currentCountry}
              options={state.region.length === 0 ? [] : state.countryList}
              isClearable={true}
            />
          </div>
        </div>
      </div>
      <div className="mt-3" style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>Timezone&nbsp;</div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              onChangeFunc={onChangeTimezone}
              options={state.zoneList}
              value={state.timeZone}
              isClearable={true}
            />
          </div>
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "baseline",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>Domains&nbsp;</div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              onChangeFunc={onChangeDomains}
              options={optionsWithSelectAllDomains}
              value={state.domains}
              isMulti={true}
              isClearable={true}
              placeholder={"Select Domains"}
            />
          </div>
        </div>
      </div>
      <div className="mt-3" style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>Seeker Identity&nbsp;</div>
          <div>
            <Switch
              value={state.si}
              onChange={(e) => onChangeSwitches("si", e)}
            />
          </div>
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>Reroute&nbsp;</div>
          <div>
            <Switch
              value={state.reroute}
              onChange={(e) => onChangeSwitches("rr", e)}
            />
          </div>
        </div>
      </div>
      <div className="mt-3" style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>Calculate Expert Score&nbsp;</div>
          <div>
            <Switch
              value={state.ces}
              onChange={(e) => onChangeSwitches("ces", e)}
            />
          </div>
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>Global&nbsp;</div>
          <div>
            <Switch
              value={state.global}
              onChange={(e) => onChangeSwitches("g", e)}
            />
          </div>
        </div>
      </div>
      <div className="mt-3" style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: "14px" }}>In-Queue&nbsp;</div>
          <div>
            <Switch
              value={state.iq}
              onChange={(e) => onChangeSwitches("iq", e)}
            />
          </div>
        </div>
      </div>
      {/* <Divider style={{marginBlock:'20px'}}/> */}
      <div className="mt-2" style={{ display: "flex" }}>
        <div
          style={{
            width: "33%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ fontSize: "14px" }}>Days&nbsp;</div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              onChangeFunc={onChangeDays}
              options={DaysArr}
              value={selecetedDays}
              isMulti={true}
              isClearable={true}
            />
          </div>
        </div>
        <div
          style={{
            width: "33%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ fontSize: "14px" }}>From&nbsp;</div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              onChangeFunc={onChangeFrom}
              options={hoursArr}
              value={fromHours}
              isClearable={true}
            />
          </div>
        </div>
        <div
          style={{
            width: "33%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ fontSize: "14px" }}>To&nbsp;</div>
          <div style={{ marginTop: "7px" }}>
            <MultiSelectCM
              onChangeFunc={onChangeTo}
              options={AllHours}
              value={toHours}
              isClearable={true}
            />
          </div>
        </div>
      </div>
      <div className="mt-2 mb-2">
        <button
          style={{
            border: "1px solid var(--light_color_shade)",
            cursor: "pointer",
            color: "#fff",
            background: "var(--light_color_shade)",
            borderRadius: "4px",
            paddingInline: "15px",
            paddingBlock: "3px",
          }}
          onClick={() => workingHors()}
        >
          Add
        </button>
      </div>
      <div
        style={{
          width: "70%",
          boxShadow: "0px 0px 3px rgb(0 0 0 / 25%)",
          marginBottom: "150px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            paddingBlock: "7px",
            alignItems: "center",
            fontWeight: "500",
          }}
        >
          <span>Active scheduling hours of days</span>
        </div>
        <table
          className="table  table-bordered"
          style={{ borderRadius: "4px" }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Day
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Scheduling hours
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {state.selectedWorkingHours.map(([day, time]) => (
              <tr key={day}>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  {day}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  {time.split("-")[0]}-{time.split("-")[1]} Hours
                </td>
                <td
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  <div>
                    <i
                      style={{ cursor: "pointer" }}
                      className="fa fa-trash"
                      onClick={() => onDeleteWorkHour(day, time)}
                    ></i>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
